import api from '@/utils/axios/api';

export default {
  async fetchAppBackground() {
    const { data: { url } } = await api.get('background');

    return url;
  },
};
